import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { InputGroup, Form, Modal, Button } from 'react-bootstrap';
import CategorySelector from './CategorySelector';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const HomePage = () => {
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null); // Nueva categoría seleccionada
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCities = async () => {
            try {
                const response = await fetch(`${API_URL}/api/cities`);
                if (!response.ok) throw new Error('Error al obtener ciudades');
                const data = await response.json();
                setCities(data);
            } catch (error) {
                console.error('Error fetching cities:', error);
            }
        };
        fetchCities();
    }, []);

    const handleSearchClick = () => {
        if (selectedCity) {
            // Navega a la página de servicios filtrando solo por ciudad,
            // permitiendo al usuario elegir una categoría allí.
            navigate(`/servicelink?city=${encodeURIComponent(selectedCity)}`);
        } else {
            setShowModal(true);
        }
    };

    return (
        <header className="App-body text-center py-5">
            <h1 className="title text-primary fw-bold font-montserrat">
                Ayuda de confianza para tareas del hogar
            </h1>
            <div className="container mt-4">
                <InputGroup className="mb-3">
                    <Form.Select
                        aria-label="Seleccionar localidad"
                        className="select-city form-control rounded-pill"
                        value={selectedCity}
                        onChange={(e) => setSelectedCity(e.target.value)}
                    >
                        <option value="">Selecciona tu localidad</option>
                        {cities.map(city => (
                            <option key={city._id} value={city.city}>{city.city}</option>
                        ))}
                    </Form.Select>
                </InputGroup>
                <div className="text-center mt-3">
                    <button
                        className="btn btn-primary rounded-pill px-4 py-2 shadow-sm"
                        onClick={handleSearchClick}
                    >
                        Buscar Servicios en mi Localidad
                    </button>
                </div>
                <CategorySelector selectedCity={selectedCity} setShowCityModal={setShowModal} />
            </div>

            {/* Modal de Advertencia */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>⚠ Atención</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Por favor, selecciona una localidad antes de buscar servicios.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </header>
    );
};

export default HomePage;
